/**
 * Created by neo on 10.06.21.
 */
import { makeAutoObservable } from 'mobx';
import { TagCondition, createTagCondition } from '../Coach/SuperMacro/TagCondition';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';

export type NotificationMessage = {
  tagCondition: TagCondition;
  title: LocalizedValue[];
  message: LocalizedValue[];
};

export function createNotificationMessage(json?: Partial<NotificationMessage>): NotificationMessage {
  return makeAutoObservable({
    tagCondition: createTagCondition(json?.tagCondition),
    title: (json?.title ?? []).map((m: any) => createLocalizedValue(m)),
    message: (json?.message ?? []).map((m: any) => createLocalizedValue(m)),
  });
}
